export default "__VITE_ASSET__f2462348__"